import { render, staticRenderFns } from "./Orderdetail_B.vue?vue&type=template&id=167c6130&scoped=true&"
import script from "./Orderdetail_B.vue?vue&type=script&lang=js&"
export * from "./Orderdetail_B.vue?vue&type=script&lang=js&"
import style0 from "./Orderdetail_B.vue?vue&type=style&index=0&id=167c6130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167c6130",
  null
  
)

/* custom blocks */
import block0 from "./Orderdetail_B.vue?vue&type=custom&index=0&blockType=el-table&%3Arow-style=%7Bheight%3A'100px'%7D&%3Acell-style=%7Bpadding%3A0%7D&%3Adata=tableData&%40selection-change=selectionChange&border=true&style=width%3A%20100%25"
if (typeof block0 === 'function') block0(component)
import block1 from "./Orderdetail_B.vue?vue&type=custom&index=1&blockType=hr"
if (typeof block1 === 'function') block1(component)

export default component.exports